import { defineMessages } from "react-intl";

export const reportsMessages = defineMessages({
  "reports.title": {
    id: "reports.title",
    defaultMessage: "Reports",
  },
  "reports.subtitle": {
    id: "reports.subtitle",
    defaultMessage: "Employees",
  },
  "reports.timeframe-filter.options.all": {
    id: "reports.timeframe-filter.options.all",
    defaultMessage: "All",
  },
  "reports.timeframe-filter.options.year": {
    id: "reports.timeframe-filter.options.year",
    defaultMessage: "12 months",
  },
  "reports.timeframe-filter.options.month": {
    id: "reports.timeframe-filter.options.month",
    defaultMessage: "30 days",
  },
  "reports.timeframe-filter.options.week": {
    id: "reports.timeframe-filter.options.week",
    defaultMessage: "7 days",
  },
  "reports.timeframe-filter.options.day": {
    id: "reports.timeframe-filter.options.day",
    defaultMessage: "24 hours",
  },
  "reports.table.col.name": {
    id: "reports.table.col.name",
    defaultMessage: "Name",
  },
  "reports.table.col.bookedSessions": {
    id: "reports.table.col.bookedSessions",
    defaultMessage: "Booked Sessions",
  },
  "reports.table.col.attendedSessions": {
    id: "reports.table.col.attendedSessions",
    defaultMessage: "Attended Sessions",
  },
  "reports.table.col.attendedStats": {
    id: "reports.table.col.attendedStats",
    defaultMessage: "Attended Sessions",
  },
});
